import React, { useState } from "react";
import { useQuery } from "react-query";
import { Link, useNavigate } from "react-router-dom";
//primereact
import { Button } from "primereact/button";
import { BreadCrumb } from "primereact/breadcrumb";
// components
import Modal from "../../components/modal/Modal";
import CardQuestionRegular from "../../components/cards/CardQuestionRegular";
import CardTraining from "../../components/cards/CardTraining";
//services
import { getTrainings } from "../../services/Trainings/getTrainings";
//context
import { useAppContext } from "../../context/AppContext";
//hooks
import usePermission from "../../hooks/usePermission";
//assets
import lands from "../../assets/Trainings/RegularQuests/Lands.png";
import dashboard from "../../assets/Trainings/RegularQuests/Dashboard.png";
import mapConfig from "../../assets/Trainings/RegularQuests/MapConfig.png";
import documents from "../../assets/Trainings/RegularQuests/Documents.png";
import discounts from "../../assets/Trainings/RegularQuests/Discounts.png";
import costCenter from "../../assets/Trainings/RegularQuests/CostCenter.png";
import printLands from "../../assets/Trainings/RegularQuests/PrintLands.png";
import salesReport from "../../assets/Trainings/RegularQuests/SalesReport.png";
import toPayReport from "../../assets/Trainings/RegularQuests/ToPayReport.png";
import paymentForm from "../../assets/Trainings/RegularQuests/PaymentForms.png";
import generalPanel from "../../assets/Trainings/RegularQuests/GeneralPanel.png";
import reverseReport from "../../assets/Trainings/RegularQuests/ReverseReport.png";
import trainingAdmin from "../../assets/Trainings/trainingAdmin.png";
import trainingBroker from "../../assets/Trainings/trainingBroker.png";
import financingEntry from "../../assets/Trainings/RegularQuests/FinancingEntry.png";
import modelContracts from "../../assets/Trainings/RegularQuests/ModelContracts.png";
import receiptsReport from "../../assets/Trainings/RegularQuests/ReceiptsReport.png";
import trainingHousing from "../../assets/Trainings/trainingHousing.png";
import trainingFinance from "../../assets/Trainings/trainingFinance.png";
import registerGeneral from "../../assets/Trainings/RegularQuests/GeneralRegistration.png";
import currentAccounts from "../../assets/Trainings/RegularQuests/CurrentAccount.png";
import contractsReadjust from "../../assets/Trainings/RegularQuests/ContractsReadjust.png";
import financingSettings from "../../assets/Trainings/RegularQuests/FinancingSettings.png";
import occurenceRegister from "../../assets/Trainings/RegularQuests/OccurenceRegister.png";
import enterpriseSettings from "../../assets/Trainings/RegularQuests/EnterpriseSettings.png";
import intermediatParcels from "../../assets/Trainings/RegularQuests/IntermediateParcels.png";
import typeRegisterReport from "../../assets/Trainings/RegularQuests/TypeRegisterReport.png";

const Trainings = () => {
  usePermission("3"); //Visualizar Treinamentos
  const { permissions } = useAppContext();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [contentModal, setContentModal] = useState("");

  const items = [
    {
      template: () => (
        <Link to={"/trainings"} className="p-breadcrumb-link">
          Treinamentos
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"/trainings"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const trainings = [
    {
      id: 1,
      title: "treinamento_corretor",
      image: trainingBroker,
      navigate: "/trainings/broker",
      progressValue: 60,
    },
    {
      id: 2,
      title: "treinamento_imobiliaria",
      image: trainingHousing,
      navigate: "/trainings/housing",
      progressValue: 50,
    },
    {
      id: 3,
      title: "treinamento_financeiro",
      image: trainingFinance,
      navigate: "/trainings/finance",
      progressValue: 50,
    },
    {
      id: 4,
      title: "treinamento_administrador",
      image: trainingAdmin,
      navigate: "/trainings/admin",
      progressValue: 90,
    },
  ];

  const questRegular = [
    {
      id: 1,
      title: "Cadastro Geral",
      image: registerGeneral,
      link: "",
    },
    {
      id: 2,
      title: "Configurações de Empreendimento",
      image: enterpriseSettings,
      link: "",
    },
    {
      id: 3,
      title: "Anexar Documentos",
      image: documents,
      link: "",
    },
    {
      id: 4,
      title: "Descontos",
      image: discounts,
      link: "",
    },
    {
      id: 5,
      title: "Entrada Financiamento",
      image: financingEntry,
      link: "",
    },
    {
      id: 6,
      title: "Parcelas Intermediárias",
      image: intermediatParcels,
      link: "",
    },
    {
      id: 7,
      title: "Configuracoes Financiamento",
      image: financingSettings,
      link: "",
    },
    {
      id: 8,
      title: "Conta Corrente",
      image: currentAccounts,
      link: "",
    },
    {
      id: 9,
      title: "Cadastro de Lotes",
      image: lands,
      link: "",
    },
    {
      id: 10,
      title: "Configuracao Mapa",
      image: mapConfig,
      link: "",
    },
    {
      id: 11,
      title: "Dashboard",
      image: dashboard,
      link: "",
    },
    {
      id: 12,
      title: "Painel Geral",
      image: generalPanel,
      link: "",
    },
    {
      id: 13,
      title: "Formas de Pagamentos",
      image: paymentForm,
      link: "",
    },
    {
      id: 14,
      title: "Imprimir Lotes",
      image: printLands,
      link: "",
    },
    {
      id: 15,
      title: "Cadastro Ocorrências",
      image: occurenceRegister,
      link: "",
    },
    {
      id: 16,
      title: "Centro de Custo",
      image: costCenter,
      link: "",
    },
    {
      id: 17,
      title: "Modelo de Contrato",
      image: modelContracts,
      link: "",
    },
    {
      id: 18,
      title: "Reajuste de Contrato",
      image: contractsReadjust,
      link: "",
    },
    {
      id: 19,
      title: "Relatorio de Recebimentos",
      image: receiptsReport,
      link: "",
    },
    {
      id: 20,
      title: "Relatorio de Vendas",
      image: salesReport,
      link: "",
    },
    {
      id: 21,
      title: "Relatorio Estorno",
      image: reverseReport,
      link: "",
    },
    {
      id: 22,
      title: "Relatorio Tipo Cadastro",
      image: typeRegisterReport,
      link: "",
    },
    {
      id: 23,
      title: "Relatorio Contas a Pagar",
      image: toPayReport,
      link: "",
    },
  ];

  const { data: dataTrainings, isLoading: isLoadingTrainings } = useQuery({
    queryKey: ["Trainings_percentage"],
    queryFn: () => getTrainings(""),
    enabled: !!permissions?.includes("3"),
  });

  //  // console.log(dataTrainings);

  // const { data: dataQuestRegular } = useQuery({
  //   queryKey: ["Quest_regular"],
  //   queryFn: () => getTrainings("/duvidas_frequentes"),
  // });
  //  // console.log(dataQuestRegular);

  return (
    <>
      <div className="col-md-12 d-flex justify-content-between">
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
        {permissions?.includes("4") && ( //Visualizar Progresso de usuario
          <Button
            label="Progresso da Equipe"
            className="btn-secondary  w-10 w-sm-10 w-md-50"
            severity="secondary"
            onClick={() => navigate(`/trainings/progress`)}
            rounded
          />
        )}
      </div>
      <div className="col-md-12 text-center mb-4 mt-3">
        <h1>
          Treinamentos <span className="text-success">Lote Mobile</span>
        </h1>
        <h4>
          Segue abaixo os nossos vídeos de treinamento para utilizar o sistema
        </h4>
      </div>
      <div className="row">
        {trainings.map((train) => {
          const percentage =
            dataTrainings && dataTrainings.find((i) => i.type === train.title);
          //          // console.log(percentage)
          return (
            <CardTraining
              key={train.id}
              navigate={train.navigate}
              image={train.image}
              disabled={
                train.title !== "treinamento_administrador" &&
                train.title !== "treinamento_imobiliaria"
              }
              loading={isLoadingTrainings}
              progressValue={
                percentage ? percentage.percentage_completed.toFixed(0) : 0
              }
            />
          );
        })}
      </div>

      {/* <div className="col-md-12 text-center mt-4">
            <h1>
              Dúvidas Frequentes <i className="fa-solid fa-circle-question"></i>
            </h1>
          </div>
          <div className="row py-2">
            {questRegular.map((quest) => {
              // const questLink = dataQuestRegular && dataQuestRegular.find((i) => i.name === quest.title);
              return (
                <CardQuestionRegular
                  key={quest.id}
                  link={quest.link}
                  image={quest.image}
                  title={quest.title}
                  setVisible={setVisible}
                  setContent={setContentModal}
                />
              );
            })}
          </div> */}

      <Modal
        visible={visible}
        position="center"
        onHide={() => setVisible(false)}
        dynamicTitle={contentModal && contentModal.title}
      >
        <>
          <video
            id="youtube-video"
            className="w-100"
            controls
            controlsList="nodownload"
          >
            <source src={contentModal && contentModal.link} type="video/mp4" />
            Seu navegador não suporta a tag de vídeo.
          </video>
        </>
      </Modal>
    </>
  );
};

export default Trainings;
